// The RetrievalClient seam (contracts.md registry row 4).
//
// Every query is tenant + app filtered by construction: accountId and appId are
// REQUIRED positional arguments, so a search cannot be issued without a tenant scope
// (00-architecture invariant 6/11; per-tenant Qdrant collections). Slice-0 ships an
// in-memory fixture; the Qdrant implementation lands behind `retrieval.qdrant_real`.
import { z } from "zod";
/** A non-empty vector of finite numbers. Non-finite entries fail closed (app-engineering §2). */
export const EmbeddingVector = z
    .array(z.number().refine(Number.isFinite, "must be finite"))
    .min(1);
//# sourceMappingURL=retrieval.js.map